import { render, staticRenderFns } from "./PddSkuInfoCard.vue?vue&type=template&id=33973456&scoped=true&"
import script from "./PddSkuInfoCard.vue?vue&type=script&lang=js&"
export * from "./PddSkuInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./PddSkuInfoCard.vue?vue&type=style&index=0&id=33973456&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33973456",
  null
  
)

export default component.exports